import { render, staticRenderFns } from "./CardTotalDPNeedApprove.vue?vue&type=template&id=daa0f2b4"
import script from "./CardTotalDPNeedApprove.vue?vue&type=script&lang=js"
export * from "./CardTotalDPNeedApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports